import type { ActivitiesDataScope } from '../types';

export function getStoreScope(scope: ActivitiesDataScope, id: number | null): string {
  return JSON.stringify({ scope, id });
}
